import script from "./Bexio-Inbox.vue?vue&type=script&setup=true&lang=js"
export * from "./Bexio-Inbox.vue?vue&type=script&setup=true&lang=js"

import "./Bexio-Inbox.vue?vue&type=style&index=0&id=652271dc&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-652271dc"]])

export default __exports__